import React from 'react'

export const LocalContext = React.createContext(
    {
        lang: 'vi',
        translate: () => null,
        changeLang: () => null
    }
)
